import { render } from "./CourseTemplate.vue?vue&type=template&id=14ea73f1"
import script from "./CourseTemplate.vue?vue&type=script&lang=js"
export * from "./CourseTemplate.vue?vue&type=script&lang=js"
script.render = render

export default script